module.exports = __webpack_public_path__ + "img/MOP.bed0916a.svg";